import React, { useEffect } from 'react';
import AOS from 'aos';
import "aos/dist/aos.css";
import './index.css';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from 'react-router-dom';
// All pages
import Home from './pages/Home';
import Contact from './pages/Contact';
import DemoProduct from './pages/DemoProduct';
import Brand from './pages/Brand';

import ScrollToTop from './components/ScrollToTop';

function App() {
  useEffect(() => {
    AOS.init({ once: true, duration: 600, easing: 'ease-out-cubic' });
    const frame = requestAnimationFrame(() => AOS.refresh());
    return () => cancelAnimationFrame(frame);
  }, []);


  return (
    <>
      <Router>
        <ScrollToTop>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/get-demo" element={<DemoProduct />} /> 
            <Route path="/brand-assets" element={<Brand />} />
          </Routes>
        </ScrollToTop>
      </Router>
    </>
  );
}


export default App;
